import { render, staticRenderFns } from "./PartnerApproval.vue?vue&type=template&id=cca6fa54&scoped=true"
import script from "./PartnerApproval.vue?vue&type=script&lang=js"
export * from "./PartnerApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca6fa54",
  null
  
)

export default component.exports